<input #datepickerInput
       class="form-control ui-datepicker"
       readonly
       autocomplete="off"
       [class.is-open]="dp?.isOpen()"
       [class.attention-input]="!isModelValid()"

       [placeholder]="placeholder ? placeholder : ('common.datepickerPlaceholder' | translate)"
       [markDisabled]="isDateNotAvailable.bind(this)"
       [disabled]="disabled"
       [dayTemplate]="customDay"
       [maxDate]="getNgbDate(maxDate)"
       [minDate]="getNgbDate(minDate)"
       [placement]="placement"
       [restoreFocus]="datepickerInput"

       [(ngModel)]="ngbModel"

       (ngModelChange)="onDateChanged($event)"
       (click)="dp?.toggle()"
       (navigate)="onMonthUpdated($event)"
       ngbDatepicker
       #dp="ngbDatepicker">
<ng-template #customDay
             let-date="date"
             let-currentMonth="currentMonth"
             let-selected="selected"
             let-disabled="disabled"
             let-focused="focused">
  <div class="btn-light"
       [class.today]="isToday(date)"
       [class.focused]="focused"
       [class.bg-pink]="selected"
       [class.selected]="selected"
       [class.disabled]="disabled"
       [class.full-capacity-day]="isFullCapacityDay(date)"
  >
    {{ date.day }}
  </div>
</ng-template>
